import { Box, Chip, Paper, Stack, Typography } from '@mui/material'
import {
  UI_COLOR_PRIMARY_ALT,
  UI_COLOR_STATUS_ACTIVE_BG,
  UI_COLOR_STATUS_ACTIVE_TEXT,
  UI_COLOR_STATUS_INACTIVE_BG,
  UI_COLOR_STATUS_INACTIVE_TEXT
} from '../../constants/uiColors'

import UserHeaderCard from './UserHeaderCard'

const USER_HEADER_COLORS = {
  title: UI_COLOR_PRIMARY_ALT,
  statusActiveBg: UI_COLOR_STATUS_ACTIVE_BG,
  statusInactiveBg: UI_COLOR_STATUS_INACTIVE_BG,
  statusActiveText: UI_COLOR_STATUS_ACTIVE_TEXT,
  statusInactiveText: UI_COLOR_STATUS_INACTIVE_TEXT
}

const isBlank = (value) => value === null || value === undefined || value === ''

const valueOrDash = (value) => (isBlank(value) ? '-' : value)

const getCardValue = (data, card) => {
  if (card.getValue) {
    return valueOrDash(card.getValue(data))
  }

  return valueOrDash(data?.[card.valueKey])
}

export default function UserHeader({ data, config, status, actions = null }) {
  if (!data || !config) return null

  return (
    <Paper elevation={3} sx={{ p: 2, borderRadius: 2, mb: 3 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', md: 'center' },
          gap: 2,
          flexDirection: { xs: 'column', md: 'row' }
        }}
      >
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Stack
            direction="row"
            spacing={1.5}
            useFlexGap
            flexWrap="wrap"
            alignItems="center"
            sx={{ mb: 1.5 }}
          >
            <Typography
              fontWeight={700}
              fontSize={20}
              sx={{ color: USER_HEADER_COLORS.title, lineHeight: 1.2 }}
            >
              {valueOrDash(data[config.titleKey])}
            </Typography>

            {status && (
              <Chip
                label={status.label}
                size="small"
                sx={{
                  minWidth: 82,
                  height: 22,
                  borderRadius: 999,
                  backgroundColor: status.active
                    ? USER_HEADER_COLORS.statusActiveBg
                    : USER_HEADER_COLORS.statusInactiveBg,
                  color: status.active
                    ? USER_HEADER_COLORS.statusActiveText
                    : USER_HEADER_COLORS.statusInactiveText,
                  fontSize: 11,
                  fontWeight: 800,
                  '& .MuiChip-label': {
                    px: 1.5
                  }
                }}
              />
            )}
          </Stack>

          <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap" alignItems="center">
            {config.cards?.map((card) => (
              <UserHeaderCard
                key={card.valueKey || card.icon}
                icon={card.icon}
                filled={card.filled}
                label={card.label}
                value={getCardValue(data, card)}
              />
            ))}
          </Stack>
        </Box>

        {actions && (
          <Box sx={{ flexShrink: 0, alignSelf: { xs: 'stretch', md: 'center' } }}>{actions}</Box>
        )}
      </Box>
    </Paper>
  )
}
